<template>
	<div>
		<Transition name="fade">
			<v-alert
				v-if="isSuccess"
				@input="$emit('toggleSucces', !isSuccess)"
				color="success lighten-2"
				dismissible
				type="success"
				text
				close-icon="mdi-close"
			>
				{{ $vuetify.lang.t("$vuetify.views.settings.alerts.changes") }}
			</v-alert>
		</Transition>
		<Transition name="fade">
			<v-alert
				@input="$emit('toggleError', !isSuccess)"
				v-if="isError"
				color="red"
				dismissible
				type="error"
				text
				close-icon="mdi-close"
			>
				{{ $vuetify.lang.t("$vuetify.views.settings.alerts.error") }}
			</v-alert>
		</Transition>
	</div>
</template>

<script>
export default {
	props: {
		isSuccess: {
			type: Boolean,
			required: true,
		},
		isError: {
			type: Boolean,
			required: true,
		},
	},

	watch: {
		isSuccess() {
			if (this.isSuccess) {
				setTimeout(
					function () {
						this.$emit("toggleSucces", false);
					}.bind(this),
					2000
				);
			}
		},
		isError() {
			if (this.isError) {
				setTimeout(
					function () {
						this.$emit("toggleError", false);
					}.bind(this),
					2000
				);
			}
		},
	},
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
	opacity: 0;
}
</style>
